// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__1dg1k","title":"CardContainer_title__1tOAA","windowsIcon":"CardContainer_windowsIcon__33Sge"};